import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Star, Quote } from 'lucide-react';
import { useState, useEffect } from 'react';

const Testimonials = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: "João Ricardo",
      date: "2021-08-15",
      rating: 5,
      text: "Almoço sensacional! Tudo estava impecável e muito bem harmonizado com os vinhos. Custo benefício muito bom.",
      title: "Excelente atendimento e refeição"
    },
    {
      name: "Juan Pablo Roca",
      date: "2021-08-09",
      rating: 5,
      text: "Era un día de frío inhóspito, pero la visita nos resultó super cálida. El almuerzo maridaje fue una excelente experiencia. La visita a la Bodega con Cecilia es muy motivadora.",
      title: "Maridaje perfecto"
    },
    {
      name: "Fabián Imaz",
      date: "2021-08-07",
      rating: 5,
      text: "Excelente lugar, hermosa bodega para almorzar y disfrutar de los jardines, viñedos y relajarse al sol. Las personas son encantadoras y los vinos espectaculares.",
      title: "Great winery!!!!"
    },
    {
      name: "Rafael R",
      date: "2021-03-22",
      rating: 5,
      text: "La visita guiada con Cecilia fue inolvidable. El almuerzo maridado en 4 pasos es muy rico y con un precio honesto. Los vinos son exquisitos.",
      title: "¡Impecable! La mejor de Montevideo"
    },
    {
      name: "Katherine P",
      date: "2021-02-27",
      rating: 5,
      text: "La experiencia de cosechar uvas y luego pisarlas, además de ser divertido, fue una experiencia diferente y placentera.",
      title: "Excelente experiencia y atención"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => 
        prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="py-20 bg-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center gap-2 mb-4">
            <Star className="h-8 w-8 text-yellow-500 fill-yellow-500" />
            <h2 className="text-4xl md:text-5xl font-bold">EXCELENTE</h2>
            <Star className="h-8 w-8 text-yellow-500 fill-yellow-500" />
          </div>
          <div className="flex justify-center gap-1 mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-6 w-6 text-yellow-500 fill-yellow-500" />
            ))}
          </div>
          <div className="flex flex-col items-center justify-center gap-2 mt-4">
            <img 
              src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_logoset_solid_green.svg" 
              alt="TripAdvisor" 
              className="h-10 md:h-12 w-auto"
            />
            <p className="text-gray-400 text-sm md:text-base">Basado en 140+ reseñas</p>
          </div>
        </motion.div>

        {/* Testimonials Carousel */}
        <div className="max-w-4xl mx-auto relative">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -100 }}
            transition={{ duration: 0.5 }}
            className="bg-gray-800 rounded-3xl p-8 md:p-12 shadow-2xl relative"
            data-testid={`testimonial-card-${currentIndex}`}
          >
            <Quote className="h-12 w-12 mb-6 opacity-50" style={{color: '#D4AF37'}} />
            
            <h3 className="text-2xl font-bold mb-4">{testimonials[currentIndex].title}</h3>
            
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              {testimonials[currentIndex].text}
            </p>

            <div className="flex items-center justify-between">
              <div>
                <p className="font-bold text-xl">{testimonials[currentIndex].name}</p>
                <p className="text-gray-400">{testimonials[currentIndex].date}</p>
              </div>
              <div className="flex gap-1">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
            </div>
          </motion.div>

          {/* Navigation Dots */}
          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex 
                    ? 'w-8' 
                    : 'w-3 bg-gray-600 hover:bg-gray-500'
                }`}
                style={index === currentIndex ? {background: '#D4AF37'} : {}}
                aria-label={`Ver testimonio ${index + 1}`}
                data-testid={`testimonial-dot-${index}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
